import { useEffect, useState } from 'react';
import { PlayerEventData } from '../../index';
import usePlayerEvent from '../usePlayerEvent/usePlayerEvent';

export default function usePlayerEventData() {
  const playerEvent = usePlayerEvent()
  const [eventData, setEventData] = useState<PlayerEventData>()

  useEffect(() => {
    if (playerEvent?.data) {
      const data = playerEvent.data
      const newEvent = new PlayerEventData(
        data.event,
        data.param,
      )
      setEventData(newEvent)
    }
  }, [playerEvent])

  return eventData
}
